import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

const ArticleRoutes: RouteRecordRaw = {
  path: '/article',
  name: 'ArticleModulePages',
  redirect: { name: 'ArticleContentCatalogRoute' },
  children: [
    {
      path: '',
      name: 'ArticleContentCatalogRoute',
      component: () => import('./views/ArticleContentCatalogView.vue'),
      meta: {
        title: 'محتواهای آموزشی',
      },
    },
    {
      path: 'catalog',
      redirect: { name: 'ArticleContentCatalogRoute' },
    },
    {
      path: 'create',
      name: 'CreateArticleContentRoute',
      component: () => import('./views/CreateArticleContentView.vue'),
      meta: {
        title: 'ایجاد محتوای آموزشی',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.articleCreate],
      },
    },
    {
      path: ':id/edit',
      name: 'EditArticleContentRoute',
      component: () => import('./views/EditArticleContentView.vue'),
      meta: {
        title: 'ویرایش محتوای آموزشی',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.articleUpdate],
      },
    },
    {
      path: ':id/content',
      name: 'ArticleContentEditorRoute',
      component: () => import('./views/ArticleContentEditorView.vue'),
      meta: {
        title: 'محتوای مقاله',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.articleUpdate],
      },
    },
    {
      path: ':id/recipients',
      name: 'ArticleContentRecipientsRoute',
      component: () => import('./views/ArticleContentRecipientsView.vue'),
      meta: {
        title: 'وضعیت دریافت کننده‌ها',
        pageHasBack: true,
      },
    },
    {
      path: ':id',
      name: 'ArticleContentDetailRoute',
      component: () => import('./views/ArticleContentDetailView.vue'),
      meta: {
        title: 'محتوای آموزشی',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    requiredPermissions: [...MODULE_PERMISSIONS.article],
  },
}

export default (router: Router) => {
  router.addRoute(ArticleRoutes)
}
